null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.29/scalalib/overrides/scala/util/DynamicVariable.scala